<template>
  <section class="snacks">
    <h1 class="snacks-section-title">Snacks</h1>
    <div class="columns-container">
      <div class="columns snack">
        <div class="column is-7 snack-image">
          <img
            src="@/assets/snacks.jpg"
            alt=""
            title="">
        </div>
        <div class="column is-5 snack-info">
          <h3>Título de Ejemplo</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
        </div>
      </div>
      <div class="columns snack">
        <div class="column is-7 snack-image">
          <img
            src="@/assets/snacks2.jpg"
            alt=""
            title="">
        </div>
        <div class="column is-5 snack-info">
          <h3>Título de Ejemplo</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
        </div>
      </div>
      <div class="columns snack">
        <div class="column is-7 snack-image">
          <img
            src="@/assets/snacks3.jpg"
            alt=""
            title="">
        </div>
        <div class="column is-5 snack-info">
          <h3>Título de Ejemplo</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
        </div>
      </div>
      <div class="columns snack">
        <div class="column is-7 snack-image">
          <img
            src="@/assets/snacks4.jpg"
            alt=""
            title="">
        </div>
        <div class="column is-5 snack-info">
          <h3>Título de Ejemplo</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Snacks',
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/initial-variables";
@import "~bulma/sass/utilities/functions";
@import "~bulma/sass/utilities/derived-variables";
@import "~bulma/sass/utilities/mixins";
@import "~@/sass/variables";

.snacks {
  margin-bottom: 2rem;

  @include tablet {
    padding: 0 4%;
  }

  .snacks-section-title {
    color: lighten($dark-cyan-gray, 30);
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    font-size: 1.25rem;
    padding-left: 4%;

    @include tablet {
      padding: 0;
    }

    @include from(1000px) {
      font-size: 1.5rem;
    }
  }

  .snack {
    margin-bottom: 3rem;
  }

  @include tablet {
    .snack:nth-of-type(odd) {
      .snack-info {
        order: -1;
      }
    }

    .snack {
      .snack-info {
        padding: 0.75rem;
      }
    }
  }

  @include desktop {
    .snack {
      margin-bottom: 0;
      &:nth-of-type(even) {
        margin-top: -3.75rem;
      }
    }
  }

  .snack-info {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-left: calc(4% + 0.75rem);
    padding-right: calc(4% + 0.75rem);

    h3{
      color: #fff;
      font-weight: bold;
      text-transform: uppercase;
      font-size: 1rem;
      text-align: left;
      width: 100%;

      @media screen and (min-width: 540px) {
        font-size: 1.25rem;
      }
    }

    p {
      color: #fff;
    }
  }
}
</style>
